module.exports = __webpack_public_path__ + "img/ico_reset.3763778.svg";